import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    modalOverlay: {
        backgroundColor: "rgba(0,0,0,0.5)",
        justifyContent: "center",
        alignItems: "center",
        flex: 1
    },
    headerRow: {
        justifyContent: "space-between",
        flexDirection: "row",
        alignItems: "center"
    },
    itemContainer: {
        backgroundColor: "transparent",
        flexDirection: "row",
        alignItems: "center"
    },
    modalActions: {
        justifyContent: "flex-end",
        flexDirection: "row"
    },
    itemIcon: {
        justifyContent: "center",
        alignItems: "center",
        height: 48,
        width: 48
    },
    itemInfo: {
        flexDirection: "column",
        flex: 1
    },
    itemActions: {
        flexDirection: "row",
        alignItems: "center"
    },
    itemContent: {
        flexDirection: "row",
        alignItems: "center",
        flex: 1
    },
    actionsRow: {
        flexDirection: "row"
    },
    selectBoxLabel: {
    },
    formContainer: {
    },
    modalContent: {
        width: 400
    },
    listContent: {
    },
    container: {
        flex: 1
    }
});
export default stylesheet;
